import React, { Fragment } from 'react';
import PropTypes, { object } from 'prop-types';

import Account from './Account/Account';
import Cell from './Cell/Cell';
import ContactCell from './ContactCell/ContactCell';
import CancellationReason from './CancellationReason/CancellationReason';
import { DateTime, Table } from 'components/common/Elements/Elements';

import { createMember } from '../../helpers/helpers';
import { moneyFormater } from 'utils/common';

import classes from './CancellationsTable.module.scss';

const TableRow = ({
  company,
  tableConf,
  row,
  mouseEnter,
  onOpenAdditionalModal,
  colorForReason
}) => {
  const big =
    company.industry !== '-' ||
    company.department !== '-' ||
    company.industry !== 'NA' ||
    company.department !== 'NA';

  return (
    <Table.Row className={classes.row}>
      {tableConf.map(({ show, field }, ind) => {
        const cellProps = {
          row: row,
          mouseEnter: mouseEnter,
          ind: ind,
          field: field,
          big: big
        };

        return (
          <Fragment key={`${field}-${company.email}}`}>
            {show && field === 'companyName' && (
              <Cell cellProps={cellProps}>
                <Account data={company} />
              </Cell>
            )}
            {show && field === 'healthStatus' && (
              <Cell cellProps={cellProps}>{company.healthStatus}</Cell>
            )}
            {show && field === 'requestedByName' && (
              <Cell cellProps={cellProps}>
                <ContactCell data={createMember(company)} />
              </Cell>
            )}
            {show && field === 'requestedAt' && (
              <Cell cellProps={cellProps}>
                <DateTime date={company.requestedAt} time />
              </Cell>
            )}
            {show && field === 'ageInMonths' && (
              <Cell cellProps={cellProps}>{company.ageInMonths}</Cell>
            )}
            {show && field === 'cancellationReason' && (
              <Cell cellProps={cellProps}>
                <CancellationReason
                  data={company}
                  onOpenAdditionalModal={onOpenAdditionalModal}
                  colorForReason={colorForReason}
                />
              </Cell>
            )}
            {show && field === 'likelyToReturn' && (
              <Cell cellProps={cellProps}>{company.likelyToReturn}</Cell>
            )}
            {show && field === 'cancellationLag' && (
              <Cell cellProps={cellProps}>{company.cancellationLag}</Cell>
            )}
            {show && field === 'arr' && (
              <Cell cellProps={cellProps}>{moneyFormater(company.arr)}</Cell>
            )}
            {show && field === 'requestRemovedAt' && (
              <Cell cellProps={cellProps}>
                <DateTime date={company.requestRemovedAt} time />
              </Cell>
            )}
            {show && field === 'nextBillingAt' && (
              <Cell cellProps={cellProps}>
                <DateTime date={company.nextBillingAt} time />
              </Cell>
            )}
          </Fragment>
        );
      })}
    </Table.Row>
  );
};

TableRow.propTypes = {
  company: PropTypes.object,
  tableConf: PropTypes.arrayOf(object),
  row: PropTypes.string,
  mouseEnter: PropTypes.func,
  onOpenAdditionalModal: PropTypes.func.isRequired,
  colorForReason: PropTypes.object
};

export default TableRow;
